import React, { FC } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'

import Address from '../components/Address'
import { actionCreators } from '../actions'
import useNetwork from '@/checkout-instore-legacy/hooks/useNetwork'

const AddressContainer: FC = (props) => {
  const addressProps = {
    ...props,
    isOnline: useNetwork(),
  }

  return <Address {...addressProps} />
}

const mapStateToProps = (state: RootState) => ({
  shipping: state.shipping,
  customer: state.customer,
  waitingForGiftCardArrival: state.returnExchange.giftCardPromise
    ? state.returnExchange.giftCardPromise.waitingForArrival
    : false,
})

const mapDispatchToProps = (dispatch: Dispatch<Action>) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(AddressContainer)
